import { render, staticRenderFns } from "./GoalBrickSettings.vue?vue&type=template&id=d597b05a&"
import script from "./GoalBrickSettings.vue?vue&type=script&lang=js&"
export * from "./GoalBrickSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d597b05a')) {
      api.createRecord('d597b05a', component.options)
    } else {
      api.reload('d597b05a', component.options)
    }
    module.hot.accept("./GoalBrickSettings.vue?vue&type=template&id=d597b05a&", function () {
      api.rerender('d597b05a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Goal/GoalBrickSettings.vue"
export default component.exports